// Cliente HTTP da Etapa 2. Mesma ideia do cliente da Etapa 1 (que não foi alterado):
// o sistema principal injeta a URL e os headers de autenticação.
import { configureApi as configureApiEtapa1 } from '../api/client'

let config = {
  baseUrl: '/api/v1' /* URL definida por configureFolhaApiEtapa6 (integração FSC) */,
  getHeaders: async () => ({}),
}

export function configureApiEtapa2({ baseUrl, getHeaders } = {}) {
  config = { baseUrl: baseUrl ?? config.baseUrl, getHeaders: getHeaders ?? config.getHeaders }
}

// Configura os clientes das duas etapas de uma vez.
export function configureFolhaApi(opcoes = {}) {
  configureApiEtapa1(opcoes)
  configureApiEtapa2(opcoes)
}

async function request(method, path, body) {
  const headers = { 'Content-Type': 'application/json', ...(await config.getHeaders()) }
  const resp = await fetch(`${config.baseUrl}${path}`, {
    method,
    headers,
    body: body === undefined ? undefined : JSON.stringify(body),
  })
  const data = await resp.json().catch(() => null)
  if (!resp.ok) {
    const detail = data?.detail
    const msg = Array.isArray(detail) ? detail.map((d) => `${d.loc?.slice(-1)[0] ?? ''}: ${d.msg}`).join('; ') : detail || resp.statusText
    throw new Error(msg)
  }
  return data
}

const q = (gravar) => (gravar ? '?gravar=true' : '')

export const apiEtapa2 = {
  calcularFerias: (entrada, gravar) => request('POST', `/ferias/calcular${q(gravar)}`, entrada),
  primeiraParcela: (entrada, gravar) => request('POST', `/decimo-terceiro/primeira-parcela${q(gravar)}`, entrada),
  segundaParcela: (entrada, gravar) => request('POST', `/decimo-terceiro/segunda-parcela${q(gravar)}`, entrada),
  calcularRescisao: (entrada, gravar) => request('POST', `/rescisao/calcular${q(gravar)}`, entrada),
  listarRegistros: (modulo, empresaId, funcionarioId) =>
    request('GET', `/registros/${modulo}?empresa_id=${encodeURIComponent(empresaId)}${funcionarioId ? `&funcionario_id=${encodeURIComponent(funcionarioId)}` : ''}`),
  confirmarPagamento: (modulo, registroId) => request('POST', `/registros/${modulo}/${registroId}/confirmar-pagamento`),
}
